module.exports = __webpack_public_path__ + "static/media/card.2579c1f5.png";